import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postFroderBulk = (params) => {
  return axiosClient
    .post(`api/admin/stats/gamer-frod/bulk`, params)
    .then((r) => r.data);
};
